import { Suspense, useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import SplashScreen from "./components/feature/SplashScreen";
import { apiSite } from "./lib/apiSite";

// Componente para scroll ao topo em mudança de rota
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  const [showSplash, setShowSplash] = useState(() => {
    // Verifica se já mostrou a splash screen nesta sessão
    return !sessionStorage.getItem('splashShown');
  });

  const handleSplashComplete = () => {
    sessionStorage.setItem('splashShown', 'true');
    setShowSplash(false);
  };

  // Atualiza o favicon dinamicamente
  useEffect(() => {
    const updateFavicon = async () => {
      try {
        const { data, error } = await apiSite
          .from('site_config')
          .select('favicon_url')
          .maybeSingle();

        if (!error && data?.favicon_url) {
          const link = document.querySelector("link[rel='icon']") as HTMLLinkElement;
          if (link) {
            link.href = data.favicon_url;
          }
        }
      } catch (err) {
        console.error('Erro ao carregar favicon:', err);
      }
    };

    updateFavicon();

    // Escuta mudanças na tabela site_config
    const channel = apiSite
      .channel('site_config_changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'site_config'
        },
        (payload) => {
          if (payload.new && (payload.new as any).favicon_url) {
            const link = document.querySelector("link[rel='icon']") as HTMLLinkElement;
            if (link) {
              link.href = (payload.new as any).favicon_url;
            }
          }
        }
      )
      .subscribe();

    return () => {
      apiSite.removeChannel(channel);
    };
  }, []);

  if (showSplash) {
    return <SplashScreen onComplete={handleSplashComplete} />;
  }

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="min-h-screen bg-cream flex items-center justify-center">
            <div className="text-forest text-xl font-serif">Carregando...</div>
          </div>
        }
      >
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
